<template>
  <v-form v-model="valid" ref="DialogForm">
    <slotted-dialog :title="$t('servicesystem.common_objects.machine.change_owner')"
      :externaltrigger="dialogtrigger" :external-close-trigger="closetrigger">
      <template v-slot:content>
        <v-container :key="dialogtrigger">
          <v-row v-if="currentCustomerId" align="center" no-gutters class="mb-4">
            <v-col>
              <h6>{{ $t('servicesystem.common_objects.commonterms.from') }}</h6>
              <CustomerSelect :value="currentCustomerId" disabled />
            </v-col>
          </v-row>
          <v-row align="center" no-gutters class="mb-6">
            <v-col>
              <h6>{{ $t('servicesystem.common_objects.commonterms.to') }}</h6>
              <CustomerSelect v-model="customerId" externaledit
                :filter="{ ExcludeItemIdList: currentCustomerId ? [currentCustomerId] : [] }" disableAttach />
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:buttons>
        <v-btn @click="closetrigger++" color="primary" outlined
          v-text="$t('servicesystem.common_objects.commonterms.cancel')">
        </v-btn>
        <v-btn :loading="loading" :disabled="!customerId" :color="customerId ? 'tertiary' : 'disabled'"
          :dark="!!customerId" @click="customerId && !loading ? save() : null">
          {{ $t('servicesystem.common_objects.commonterms.save') }}
        </v-btn>
      </template>
    </slotted-dialog>
  </v-form>
</template>

<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import CustomerSelect from "@/components/Inputs/EntityDropdowns/CustomerSelect2.vue";
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";

export default {
  name: "ChangeContractCustomerDialog",
  props: {
    externaltrigger: Number,
    contractId: {
      type: [Number, String],
      required: true,
    },
    currentCustomerId: String,
  },
  components: {
    SlottedDialog,
    CustomerSelect,
  },
  mixins: [clientAPI],

  data() {
    return {
      dialogtrigger: 0,
      closetrigger: 0,
      customerId: null,
      valid: false,
      loading: false,
    };
  },

  methods: {
    async save() {
      this.loading = true;
      await this.changeContractCustomer(this.contractId, this.customerId)
        .then((updatedContract) => {
          this.$emit("Changed", updatedContract);
          this.closetrigger++;
        })
        .catch(() => { })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  watch: {
    externaltrigger() {
      this.customerId = null;
      this.dialogtrigger++;
    },
  },
};
</script>
